import "moment";
import CRUDTableEntity from "./CRUDTableEntity";
export default class AuthInfo extends CRUDTableEntity {
    constructor(obj) {
        super(obj['partitionKey'], obj['rowKey']);
        this.Company = obj['Company'];
        this.LicenceType = obj['LicenceType'];
        this.Name = obj['Name'];
        this.Roles = obj['Roles'];
        this.ValidFrom = new Date(Date.parse(obj['ValidFrom']));
        this.ValidTo = new Date(Date.parse(obj['ValidTo']));
        this.partitionKey = obj['partitionKey'];
        this.rowKey = obj['rowKey'];
        this.timestamp = new Date(Date.parse(obj['timestamp']));
    }
    isValid() {
        let now = new Date();
        return now.valueOf() - this.ValidFrom.valueOf() > 0 && this.ValidTo.valueOf() - now.valueOf() > 0;
    }
    daysTillExpiry() {
        if (!this.isValid()) {
            return 0;
        }
        let now = new Date();
        return Math.floor((this.ValidTo.valueOf() - now.valueOf()) / (1000 * 3600 * 24));
    }
}
